import { render, staticRenderFns } from "./product-switch-button.vue?vue&type=template&id=02fdefa4&scoped=true"
import script from "./product-switch-button.vue?vue&type=script&lang=js"
export * from "./product-switch-button.vue?vue&type=script&lang=js"
import style0 from "./product-switch-button.vue?vue&type=style&index=0&id=02fdefa4&prod&scoped=true&lang=css"
import style1 from "./product-switch-button.vue?vue&type=style&index=1&id=02fdefa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fdefa4",
  null
  
)

export default component.exports